<template>
  <div>
    <div class="price-item-border shadow-sm" @click="selectSku(skus)">
      <div class="row">
        <div class="col-3 d-flex align-items-center">
          <div class="gift-icon-bg" :class="background">
            <span class="icon gift"></span>
          </div>
        </div>
        <div class="col-6 p-0">
          <div class="rate-container">
            <div>
              <div class="rate-title d-flex gap-2">
                <div class="days">{{ getDay(skus.description) }}</div>
                <div>
                  {{ skus.skuName }}
                </div>
              </div>
              <div class="rate-description fw-semibold">
                {{ skus.description }}
              </div>

              <div class="small-description fw-normal" v-if="isExtraboost">
                Reach out to your distributor to avail the Xperience Hub
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 d-flex align-items-center p-2">
          <div class="price-item" :class="background">
            <div>
              <div class="currency">PHP</div>
              <div class="price">
                {{ skus.price }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkuItem",
  // data() {
  //   return {
  //     selectedSku: "",
  //   };
  // },
  props: {
    // skuTitle: {
    //   type: String,
    // },

    skus: {
      type: Object,
      default() {
        return {};
      },
    },

    isExtraboost: {
      type: Boolean,
      default: false,
    },

    background: {
      type: String,
    },

    isClickable: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    getDay(str) {
      const match = str.match(/(\d+\s*days?)/i);
      return match ? match[0] : null;
    },

    selectSku(data) {
      if (!this.isClickable) return;
      let sku = {
        name: "",
        items: [],
        background: this.$props.background,
      };
      sku.items.push(data);
      this.$store
        .dispatch("ADD_SKU", sku)
        .then(() => {
          this.$router.push({ path: "/checkout" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  computed: {
    // selectedSku() {
    //   const isEmpty = Object.keys(this.$store.getters.GET_SKU).length === 0;
    //   if (!isEmpty) {
    //     return this.$store.getters.GET_SKU.items[0].skuId;
    //   }
    //   return 0;
    // },
  },
};
</script>

<style scoped>
.days {
  display: flex;
  height: 21px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 2.542px;
  border-radius: 3.813px;
  background: #ffb63b;

  color: #000;
  text-align: center;
  font-family: "Open Sans";
  font-size: 9.533px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.small-description {
  margin-top: 8px;
  color: #000;
  font-family: "Open Sans";
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 136.229%; /* 10.898px */
}
</style>
